import { render } from "./elektraWeb.vue?vue&type=template&id=bd448d32"
import script from "./elektraWeb.vue?vue&type=script&lang=js"
export * from "./elektraWeb.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__